module.exports = __webpack_public_path__ + "assets/0418cacd4ebf73bbe0c5b225905bd204.png";